<!-- 由 suu 创建于 2021-12-28 星期二 -->
<template>
  <div class="die-selection-pro">
    <!-- 头部 -->
    <img
      class="dsp-top"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/syr-nor-top"
      alt=""
    />
    <!-- 奖励 -->
    <div class="dsp-panel">
      <div class="p-title">我的奖励</div>
      <template v-if="info.gift_list && info.gift_list.length">
        <div class="p-get" v-for="(item, index) in info.gift_list" :key="index">
          <div class="g-left">
            {{ item.name }}<span>x{{ item.num || 1 }}</span
            ><span class="new-flag" v-if="item.type == 2">新用户专享</span>
          </div>
          <div class="g-right" @click="handelUse(item)">去使用</div>
        </div>
      </template>
      <div class="dsp-no" v-else>暂无奖励</div>
    </div>
    <!-- 邀请 -->
    <div class="dsp-panel">
      <div class="p-title">邀请记录</div>
      <template v-if="invitation && invitation.length">
        <div
          class="p-get p-invit"
          v-for="(item, index) in invitation"
          :key="index"
        >
          <div class="i-left">
            <img class="l-img" :src="item.head_img" alt="" />
            <div class="l-name">
              {{ item.truename }}
              <br />
              <span>{{ item.addtime.slice(0, 16).replace(/-/g, '.') }}</span>
            </div>
          </div>
          <div class="i-right" v-if="item.c_name">
            已打call
            <br />
            <span>{{ item.c_name }}</span>
          </div>
        </div>
      </template>
      <div class="dsp-no" v-else>暂无</div>
    </div>
    <div class="dsp-footer">
      <img
        class="f-img"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-jzy-logo"
        alt=""
      />
      <div class="f-line"></div>
      <img
        class="f-img f-img-2"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/24da8650c5efff164cc4fb70e8d11805.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'die-selection-pro',

  components: {},

  props: {},

  data() {
    return {
      isAPP: false, // 是否在app
      isMini: false,
      info: {
        gift_list: []
      },
      invitation: []
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getInfo()
    this.getInvit()
    if (this.$http._isApp()) {
      this.isAPP = true
    } else {
      wx.miniProgram.getEnv((res) => {
        this.isMini = res.miniprogram
        this.getStr()
      })
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 使用奖励
     */
    handelUse(item) {
      if (this.isAPP) {
        let mId = 'gh_a0874cf4204c'
        if (item.type == 2) {
          mId = 'gh_0d804ee2c21b'
        }
        this.$betterwe.onAppPageRoute({
          path: 'miniProgram', //跳转页面路径
          //跳转所需参数
          params: [
            { key: 'userName', value: mId },
            { key: 'path', value: item.url }
          ]
        })
      }
    },
    /**
     * 获取活动信息
     */
    getInfo() {
      this.$http.getApp('member/AppVote/getVoteInfo', {}).then((res) => {
        this.info = res.data.data
        // this.voteNum = -1
      })
    },
    /**
     * 获取邀请列表
     */
    getInvit() {
      this.$http.getApp('member/AppVote/inviteList', {}).then((res) => {
        this.invitation = res.data.data || []
        // this.voteNum = -1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.die-selection-pro {
  width: 100vw;
  position: relative;
  min-height: 100vh;
  background-color: #fff1f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  .dsp-top {
    width: 100%;
    box-sizing: border-box;
  }
  .dsp-panel {
    width: 335px;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 20px;
    border: 1px solid #fbe1db;
    margin-top: 20px;
    box-sizing: border-box;
    .dsp-no {
      margin-top: 20px;
      font-size: 14px;
      color: #666;
      text-align: center;
    }
    .p-title {
      font-size: 24px;
      font-weight: 600;
      font-family: FZLTH8K--GBK1-0, FZLTH8K--GBK1;
      color: #333333;
      line-height: 30px;
      background: linear-gradient(150deg, #eb659b 0%, #f5af93 50%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .p-get {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      .g-left {
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 10px;
          font-weight: 400;
          margin-left: 10px;
        }
        .new-flag {
          height: 15px;
          background: #ff5a5a;
          border-radius: 3px;
          padding: 0px 6px;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 15px;
          margin-left: 8px;
          margin-right: 8px;
          flex-shrink: 0;
        }
      }
      .g-right {
        width: 73px;
        height: 24px;
        background: #fff5dc;
        border-radius: 6px;
        border: 1px solid #e8d8c1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 500;
        color: #383d48;
      }
      & + .p-get {
        padding-top: 20px;
        border-top: 1px dashed rgba($color: #000000, $alpha: 0.15);
      }
    }
    .p-invit {
      .i-left {
        display: flex;
        align-items: center;
        justify-content: center;
        .l-img {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          margin-right: 10px;
        }
        .l-name {
          font-size: 14px;
          font-weight: 600;
          word-break: break-all;
          span {
            color: #999;
            font-weight: 400;
          }
        }
      }
      .i-right {
        font-size: 12px;
        color: #999;
        span {
          display: block;
          margin-top: 2px;
        }
      }
    }
  }
  .dsp-footer {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 18px;
    padding-bottom: 40px;
    .f-img {
      width: 90px;
    }
    .f-line {
      width: 2px;
      height: 30px;
      background-color: #f4d6d6;
      margin: 0 12px;
    }
  }
}
</style>
